module.exports = __webpack_public_path__ + "static/media/Vector-15.2b330041.svg";